import { render } from "./account-page-header-component.vue?vue&type=template&id=a9e13528&ts=true"
import script from "./account-page-header-component.vue?vue&type=script&lang=ts"
export * from "./account-page-header-component.vue?vue&type=script&lang=ts"

import "./account-page-header-component.vue?vue&type=style&index=0&id=a9e13528&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__